import { Typography } from "@mui/material";
import IconButtonCancel from "components/Buttons/IconButtonCancel";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { TextPluralization } from "components/TextPluralization";
import * as React from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
    count: number;
    resource: string;
    additionalInfo?: string | React.ReactElement;

    filtered?: boolean;
    filteredResource?: string;
    onResetFilter?: () => void;
}

type Props = IProps;

const CountFilter: React.FC<Props> = (props) => {
    const { t } = useTranslation();

    return (
        <Typography variant="subtitle2" component="span">
            <MuiColor variant="muted">
                <TextPluralization
                    resource={
                        props.filtered && props.filteredResource
                            ? props.filteredResource
                            : !props.filtered && props.resource
                                ? props.resource
                                : "Common.Filter.ResultText"
                    }
                    count={props.count}
                />
                {
                    props.additionalInfo &&
                    <>&nbsp;{props.additionalInfo}</>
                }
            </MuiColor>
            {
                props.filtered && props.onResetFilter &&
                <IconButtonCancel title={t("Common.Filter.ResetText")} onClick={props.onResetFilter} size="small" />
            }
        </Typography>
    );
};

CountFilter.defaultProps = {
    filtered: false
}

export default CountFilter;
